import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import SalesTarget from "../../../containers/modules/sales/sales-target";

export default function SalesTargetRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="sales-target"
      index
    element={
    <AccessControl
        name={"Sales Target List"}
        auth={authUser}
        component={() => <SalesTarget />}
    />
    }
    />
  );
}
